import React from 'react';

export default () => (
    <svg width="17px" height="16px" viewBox="0 0 17 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="R2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
            <g id="Dashboard-Search-Patient" transform="translate(-320.000000, -167.000000)" stroke="#353535" strokeWidth="1.5">
                <g id="Group-7" transform="translate(321.498617, 169.000000)">
                    <line x1="0.729550265" y1="0.037493633" x2="13.1761456" y2="12.4840889" id="Line"></line>
                    <line x1="0.33958595" y1="0.037493633" x2="12.7861812" y2="12.4840889" id="Line-Copy" transform="translate(6.611111, 6.611111) scale(-1, 1) translate(-6.611111, -6.611111) "></line>
                </g>
            </g>
        </g>
    </svg>
);
